export default {"src":"/_next/static/media/pattern-recognition-mod.f283dd95.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};